export const traditionalChineseDialogText = {
  "--all fields--": "--所有欄位--",
  "--Choose a dataset to clone--": "--選擇要複製的資料集--",
  "--Please choose an field--": "--請選擇欄位--",
  "--Please choose an option--": "--請選擇選項--",
  "--pure images--": "--純圖片--",
  "1. Go to": "1. 前往",
  "2. After uploading, please click the": "2. 上傳完成後，請點選",
  "2. Go to": "2. 前往",
  "Add new folder": "新增資料夾",
  Advanced: "進階",
  "Advanced Parameters": "進階參數",
  "After starting upload you can switch pages; progress continues in the corner.":
    "開始上傳後可切換頁面，進度會繼續顯示在畫面角落。",
  "and you cannot make any changes to the dataset.":
    "，且您無法對此資料集進行任何變更。",
  Annotation: "標註",
  "Annotation Workspace": "標註工作區",
  "Anomaly Synthesis": "異常合成",
  "Anomaly Type": "異常類型",
  Application: "應用類型",
  attack: "攻擊",
  audio: "音訊",
  AUDIO: "音訊",
  "Audio Sources": "音訊來源",
  "Batch ETL Custom Parameters": "批次 ETL 自訂參數",
  Browse: "瀏覽",
  "Check Storage": "檢查儲存空間",
  "Check unqualified documents.": "檢查不合格的文件。",
  "Choose Data": "選擇資料",
  "Choose field (sync pre-annotation)": "選擇欄位（同步預先標註）",
  "Choose Model": "選擇模型",
  "Choose Models:": "選擇模型：",
  "Choose Operation Level": "選擇操作層級",
  "Choose split:": "選擇資料分割：",
  "Choose Sub DAG:": "選擇子 DAG：",
  "Choose zoo dataset:": "選擇模型庫資料集：",
  "Choose zoo model:": "選擇模型庫模型：",
  "Class Name": "類別名稱",
  "Class Operations": "類別操作",
  "Classes:": "類別：",
  Completed: "已完成",
  "Confidence threshold:": "信心分數閾值：",
  "Contains keyword:": "包含關鍵字：",
  "Convert succeeded training outputs into platform-ready NEF packages.":
    "將訓練成功的輸出轉換為可供平台使用的 NEF 套件。",
  Count: "數量",
  "Create CVAT Project": "建立 CVAT 專案",
  "Create Dataset": "建立資料集",
  "Create New Project": "建立新專案",
  Created: "建立時間",
  "Current priority:": "目前優先順序：",
  "Custom ETL Parameters": "自訂 ETL 參數",
  "CVAT Task ID:": "CVAT 任務 ID：",
  "DAG Selection": "DAG 選擇",
  "Data Cleansing": "資料清理",
  "Data Generation": "資料產生",
  "Dataset Name": "資料集名稱",
  "Dataset overview": "資料集概覽",
  "dataset picker page": "資料集挑選",
  "dataset cutter page": "資料集切割",
  "dataset(s)": "個資料集",
  "dataset:": "資料集：",
  "Delete Dataset": "刪除資料集",
  "Delete Folder": "刪除資料夾",
  "Delete Redundant": "刪除重複項目",
  "Delete Redundant Samples": "刪除重複樣本",
  "Delete Selected Samples": "刪除所選樣本",
  "Deployment Artifact": "部署成品",
  "Do not sync": "不要同步",
  "Download Page": "下載頁面",
  "Download?": "要下載嗎？",
  "Drag and drop a file or zip here, or click Browse":
    "將檔案或 ZIP 拖放到此處，或點選「瀏覽」",
  "Drag and drop a file or zip here, or click Browse. You can leave this page after starting upload; progress continues in the corner.":
    "將檔案或 ZIP 拖放到此處，或點選「瀏覽」。開始上傳後可離開此頁面，進度會繼續顯示在畫面角落。",
  "e.g. 0~10": "例如 0～10",
  "e.g. 1": "例如 1",
  "e.g. 1~10": "例如 1～10",
  "e.g. a photo of a cat sitting on a chair": "例如：一隻坐在椅子上的貓",
  "e.g. hole, crack, scratch": "例如：孔洞、裂痕、刮痕",
  "e.g. Plastic products": "例如：塑膠製品",
  "e.g. replace the background with a clean white studio":
    "例如：將背景替換為乾淨的白色攝影棚",
  "Empty dataset": "空白資料集",
  "end index": "結束索引",
  "Enter dataset name": "輸入資料集名稱",
  "Enter group name": "輸入群組名稱",
  "Error Message:": "錯誤訊息：",
  "Error:": "錯誤：",
  "ETL Input": "ETL 輸入",
  "Evaluation Results": "評估結果",
  Failed: "失敗",
  "Failed Components:": "失敗的元件：",
  "Field Operations": "欄位操作",
  "File Filter Regex": "檔案篩選正規表示式",
  "file number:": "檔案數量：",
  "File:": "檔案：",
  Finished: "已完成",
  Folder: "資料夾",
  "Folder Name": "資料夾名稱",
  "folder type:": "資料夾類型：",
  FR: "人臉辨識",
  "FR Mode": "人臉辨識模式",
  "Frame Rate": "影格率",
  "Frame Rate in fps": "影格率（fps）",
  "Full Model Details": "完整模型詳細資料",
  "Generate images from text prompts using Stable Diffusion 1.5 and add them to the current dataset.":
    "使用 Stable Diffusion 1.5 依文字提示詞產生圖片，並加入目前的資料集。",
  "Generate NEF": "產生 NEF",
  "Generate NEF for:": "產生 NEF：",
  Generating: "產生中",
  "Gray: Exists in the public field, not in prediction labels, It is necessary to rename the label in the prediction labels by referring to the labels in the public field;":
    "灰色：存在於公用欄位，但不在預測標籤中；需要參考公用欄位中的標籤，重新命名預測標籤。",
  "Green: Exists in both prediction labels and public field;":
    "綠色：同時存在於預測標籤與公用欄位中。",
  Group: "群組",
  "Group Management": "群組管理",
  "Group Name:": "群組名稱：",
  "has label:": "具有標籤：",
  Height: "高度",
  "If the input frame rate is greater than 5, it will take 5 to convert to frames.":
    "若輸入影格率大於 5，轉換影格時將使用 5。",
  "If you want to add new samples to folder dataset,":
    "若要將新樣本加入資料夾資料集，",
  "If you want to operate the dataset, please contact the admin user to help upgrade your role to":
    "若要操作此資料集，請聯絡管理員將您的角色升級為",
  "If you want to process data in a folder dataset,":
    "若要處理資料夾資料集中的資料，",
  "If you want to split a folder dataset,": "若要分割資料夾資料集，",
  IMAGE: "圖片",
  image: "圖片",
  "Image Quality (%)": "圖片品質（%）",
  "Image Quality in %": "圖片品質（%）",
  "Images per Source": "每個來源的圖片數",
  "Import Storage": "匯入儲存空間",
  "Insufficient permissions": "權限不足",
  "Invite new member to": "邀請新成員加入",
  "Invitee email": "受邀者電子郵件",
  "IOU threshold:": "IoU 閾值：",
  "IP Evaluation for:": "IP 評估：",
  "IP Evaluator": "IP 評估器",
  "is typically the frequency at which consecutive images are captured or displayed.":
    "通常是連續圖片被擷取或顯示的頻率。",
  "Item Name": "項目名稱",
  "Keep 1 sample every": "每隔以下數量保留 1 個樣本",
  "Keep mask": "保留遮罩",
  "Label Operations": "標籤操作",
  "Label Studio Projects": "Label Studio 專案",
  "Labels are synced from FiftyOne fields when you upload datasets.":
    "上傳資料集時，標籤會從 FiftyOne 欄位同步。",
  "Labels:": "標籤：",
  "Launch training pipelines, monitor run status, and manage generated model artifacts.":
    "啟動訓練管線、監控執行狀態，並管理產生的模型成品。",
  "LLM Annotation Tool": "LLM 標註工具",
  Liveness: "活體偵測",
  "Load Table": "載入資料表",
  "Load to Dataset": "載入至資料集",
  "Loading...": "載入中...",
  "Manage audio annotation projects, storage imports, exports, and ETL handoff.":
    "管理音訊標註專案、儲存空間匯入、匯出與 ETL 交接。",
  Mapping: "對應設定",
  "Max Iterations": "最大反覆運算次數",
  "Max sample number:": "最大樣本數：",
  "Media Type": "媒體類型",
  "media type:": "媒體類型：",
  "Media type:": "媒體類型：",
  Member: "成員",
  Members: "成員",
  "Merge Datasets": "合併資料集",
  Mode: "模式",
  Model: "模型",
  "Model ID": "模型 ID",
  "Model Information:": "模型資訊：",
  "Model Mode": "模型模式",
  "Model:": "模型：",
  "model(s)": "個模型",
  "model:": "模型：",
  "New Dataset Name": "新資料集名稱",
  "new field name": "新欄位名稱",
  "new label name": "新標籤名稱",
  "No advanced parameters.": "沒有進階參數。",
  "No classes yet": "尚無類別",
  "No dataset in your workspace.": "工作區中沒有資料集。",
  "No eligible models yet. Complete training before generating NEF.":
    "尚無符合條件的模型；請先完成訓練再產生 NEF。",
  "No file chosen": "尚未選擇檔案",
  "No Label in this dataset": "此資料集中沒有標籤",
  "No Label Studio projects yet. Create a project to start annotation.":
    "尚無 Label Studio 專案；請建立專案以開始標註。",
  "No matching dataset found": "找不到符合的資料集",
  "No organization": "沒有組織",
  "No source images found.": "找不到來源圖片。",
  "No training runs yet. Choose a model to start a pipeline.":
    "尚無訓練紀錄；請選擇模型以啟動管線。",
  "Optionally select a source image for editing, or leave it empty for text-to-image generation.":
    "可選擇一張來源圖片進行編輯，或留空以使用文字產生圖片。",
  "Optionally select one or more source images for editing, or leave empty for text-to-image generation.":
    "可選擇一張或多張來源圖片進行編輯，或留空以使用文字產生圖片。",
  "Organization": "組織",
  Organizer: "組織者",
  "Overwrite?": "要覆寫嗎？",
  "page and choose a model to do inference.": "頁面並選擇模型進行推論。",
  "page and do the annotation.": "頁面進行標註。",
  "People with access to": "可存取以下項目的人員：",
  Platform: "平台",
  "Please choose a DAG": "請選擇 DAG",
  "Please choose a document.": "請選擇文件。",
  "Please choose a keyword.": "請選擇關鍵字。",
  "Please choose a Label field": "請選擇標籤欄位",
  "Please choose a model": "請選擇模型",
  "Please choose a pre-define class": "請選擇預先定義的類別",
  "Please choose an field": "請選擇欄位",
  "Please choose an label class": "請選擇標籤類別",
  "Please choose an option": "請選擇選項",
  "Please choose FR mode": "請選擇人臉辨識模式",
  "Please click": "請點選",
  "please click 'Folders' tab, and you can upload data there.":
    "請點選「資料夾」頁籤，即可在該處上傳資料。",
  "please click 'Folders' tab, but this feat is not implemented yet.":
    "請點選「資料夾」頁籤，但此功能目前尚未實作。",
  "Please enter table name": "請輸入資料表名稱",
  "Please select": "請選擇",
  "Please Type File Name": "請輸入檔案名稱",
  "Please Type Your Path": "請輸入路徑",
  "Pre-Label": "預先標註",
  "Priority (1-10, higher number = higher priority)":
    "優先順序（1～10，數字越大優先順序越高）",
  "Project ID:": "專案 ID：",
  "Project Name": "專案名稱",
  Projects: "專案",
  Prompt: "提示詞",
  "Prompt Labels": "提示標籤",
  "Quality Threshold": "品質閾值",
  Ready: "就緒",
  real: "真實",
  report: "報告",
  "Red: Exists in prediction labels, not in public fields, It is necessary to rename the label, delete it or add the new label to dbmap;":
    "紅色：存在於預測標籤，但不在公用欄位中；需要重新命名或刪除標籤，或將新標籤加入 dbmap。",
  "Reformat?": "要重新格式化嗎？",
  Regular: "一般成員",
  "Removing a member revokes their access immediately":
    "移除成員會立即撤銷其存取權",
  "respath:": "結果路徑：",
  Role: "角色",
  Running: "執行中",
  Samples: "樣本數",
  "samples num:": "樣本數：",
  "Samples:": "樣本數：",
  "Save mask images with anomaly images; turn off to discard masks":
    "將遮罩圖片與異常圖片一併儲存；關閉後將捨棄遮罩。",
  Saved: "已儲存",
  "Search Dataset...": "搜尋資料集...",
  "Select for batch ETL": "選取以進行批次 ETL",
  Selected: "已選取",
  "Selected dataset:": "已選資料集：",
  "Selected Datasets (": "已選資料集（",
  "Selected max sample number:": "已選最大樣本數：",
  "Selected split:": "已選資料分割：",
  "Set Priority for": "設定優先順序：",
  Showing: "顯示",
  "Silver Table Path": "Silver 資料表路徑",
  Size: "大小",
  "size:": "大小：",
  "Size:": "大小：",
  "Skip evaluation": "略過評估",
  "Skip quality scoring and save generated images directly":
    "略過品質評分並直接儲存產生的圖片。",
  "Source image": "來源圖片",
  "Split": "資料分割",
  "split number": "分割數量",
  "stage:": "階段：",
  "start index": "起始索引",
  "Status Check Page": "狀態檢查頁面",
  "status:": "狀態：",
  "Step1. Create Folder (Optional)": "步驟 1：建立資料夾（選填）",
  "Step2. Choose Folder and Upload": "步驟 2：選擇資料夾並上傳",
  "Storage Title": "儲存空間標題",
  Succeeded: "成功",
  "System available space:": "系統可用空間：",
  "Systematic sampling": "系統取樣",
  "Table Name": "資料表名稱",
  "target dataset name": "目標資料集名稱",
  Tasks: "任務",
  table: "資料表",
  test: "測試",
  text: "文字",
  "There is no field in this dataset": "此資料集中沒有欄位",
  "They'll receive an email invite to join this workspace":
    "對方將收到加入此工作區的電子郵件邀請。",
  "To create a new field:": "若要建立新欄位：",
  "to create one.": "以建立資料集。",
  "To get labels, please:": "若要取得標籤，請：",
  "to reduce dataset size while preserving sample distribution.":
    "縮減資料集大小，同時保留樣本分布。",
  Total: "總計",
  "Total Files:": "檔案總數：",
  "Total Labels:": "標籤總數：",
  train: "訓練",
  "Train Models": "訓練模型",
  "Try adjusting your search keywords": "請嘗試調整搜尋關鍵字",
  "Tips: You can click X to leave here, we will continue to process your request in the background.":
    "提示：您可以點選 X 離開此處，系統會在背景繼續處理要求。",
  "Tips: 1. If you are uploading a compressed file, it will be auto unzipped. 2. If you are uploading a video file. it will be auto converted to frame images. 3. If you are uploading a compressed video file, it will be auto unzipped & converted to images.":
    "提示：1. 上傳壓縮檔時會自動解壓縮。2. 上傳影片檔時會自動轉換為影格圖片。3. 上傳壓縮影片檔時會自動解壓縮並轉換為圖片。",
  Type: "類型",
  "Uniqueness Threshold": "唯一性閾值",
  "Upload Data": "上傳資料",
  "Upload File": "上傳檔案",
  Use: "使用",
  val: "驗證",
  validation: "驗證",
  "Valid:": "有效：",
  VIDEO: "影片",
  video: "影片",
  Width: "寬度",
  Workspace: "工作區",
  "You can not add samples on dataset that represents a folder/table":
    "無法將樣本加入代表資料夾或資料表的資料集。",
  "You can not split dataset that represents a folder/table":
    "無法分割代表資料夾或資料表的資料集。",
  "You can process data in dataset that represents a folder/table":
    "可以處理代表資料夾或資料表的資料集。",
  "Your role is": "您的角色是",
  ". higher numbers have higher priority for training pipeline access.":
    "。數字越大，使用訓練管線的優先順序越高。",
  "YouTube Link:": "YouTube 連結：",
  "(optional)": "（選填）",
  "(required)": "（必填）",
  "· multi-select (max": "· 多選（上限",
  "Edit prompt": "編輯提示詞",
  "Select one image from this dataset, then describe the changes to make.":
    "從此資料集中選擇一張圖片，然後描述要進行的變更。",
  "Select one or more images from this dataset, then describe the changes to make.":
    "從此資料集中選擇一張或多張圖片，然後描述要進行的變更。",
};

export const traditionalChineseDialogPatterns = [
  [/^default:\s*(.+)$/i, "預設：$1"],
  [/^Batch ETL \((\d+)\)$/, "批次 ETL（$1）"],
  [/^Showing (\d+)-(\d+) of (\d+) datasets$/, "顯示第 $1～$2 筆，共 $3 個資料集"],
  [/^Total (\d+) items$/, "共 $1 個項目"],
  [/^Selected (\d+) dataset\(s\)$/, "已選取 $1 個資料集"],
  [/^Selected (\d+) model\(s\)$/, "已選取 $1 個模型"],
  [/^Current priority:\s*(.+)$/, "目前優先順序：$1"],
  [/^Set Priority for (.+)$/, "設定「$1」的優先順序"],
  [/^Invite new member to (.+)$/, "邀請新成員加入「$1」"],
  [/^People with access to (.+)$/, "可存取「$1」的人員"],
  [/^Generate NEF for:\s*(.+)$/, "為「$1」產生 NEF"],
  [/^IP Evaluation for:\s*(.+)$/, "「$1」的 IP 評估"],
];
